export default "__VITE_ASSET__9a23751c__"